import {
  ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_SUCCESS,
  ADD_TO_WISHLIST_ERROR,
  FETCH_WISHLIST_ITEMS,
  FETCH_WISHLIST_ITEMS_SUCCESS,
  FETCH_WISHLIST_ITEMS_ERROR,
  REMOVE_WISHLIST_ITEM,
  REMOVE_WISHLIST_ITEM_SUCCESS,
  REMOVE_WISHLIST_ITEM_ERROR,
} from 'store/actionTypes';

const INIT_STATE = {
  items: [],
  modifiedData: null,
  error: '',
  modifying: false,
  loading: false,
  itemPagination: {
    current: 0,
    pageSize: 4,
    total: 0,
  },
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_TO_WISHLIST:
      return {
        ...state,
        modifying: true,
        modifiedData: null,
        error: '',
      };
    case ADD_TO_WISHLIST_SUCCESS:
      return {
        ...state,
        modifying: false,
        modifiedData: action.payload,
        error: '',
      };
    case ADD_TO_WISHLIST_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    case FETCH_WISHLIST_ITEMS:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_WISHLIST_ITEMS_SUCCESS:
      const { current, pageSize = 4, total = 0 } = action.pageData;

      return {
        ...state,
        loading: false,
        items: [...action.payload],
        error: '',
        itemPagination: {
          current,
          pageSize,
          total,
        },
      };
    case FETCH_WISHLIST_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case REMOVE_WISHLIST_ITEM:
      return {
        ...state,
        modifying: true,
        error: '',
        modifiedData: null,
      };
    case REMOVE_WISHLIST_ITEM_SUCCESS: {
      return {
        ...state,
        modifying: false,
        modifiedData: action.payload,
        error: '',
      };
    }
    case REMOVE_WISHLIST_ITEM_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
